import React, { useEffect } from "react";
import { generateGuid } from "./kendo_common";

export const KendoLoader = ({
  className = "d-flex justify-content-center align-items-center",
}) => {
  var guid = generateGuid();

  useEffect(() => {
    $("#" + guid)
      .kendoLoader({
        themeColor: "secondary",
      })
      .data("kendoLoader");
  }, []);
  return (
    <div style={{ width: "100%", height: "100%" }} className={className}>
      <div id={guid}></div>
    </div>
  );
};
